'use client';
import useViewItem from '@/hooks/useViewItem';
import { useState } from 'react';
import BundleDeal from './bundle-deal';
import CtaButtons from './cta-buttons';
import ExtraStores from './extra-stores';
import FindStore from './find-store';
import Media from './media';
import ProductDelivery from './product-delivery';
import ProductDetail from './product-detail';

const Details = ({ product, session }) => {
  const [selectedBundle, setSelectedBundle] = useState(null);

  useViewItem(product);

  return (
    <div className='relative mt-3 flex flex-wrap max-lg:gap-[11px]'>
      <div className='w-full lg:w-[70%]'>
        <div className='z-25 grid grid-cols-1 gap-3 lg:grid-cols-2 lg:gap-5.5'>
          <Media
            images={product?._media_?.image}
            sku={product?.sku}
            product={product}
            labels={product?.label || []}
            title={product?.name?.[0]}
            description={product?.data?.[0]?.meta_description}
            price={product?.prices_with_tax}
          />
          <ProductDetail
            showDiscountLabel={product?.tier_prices?.length > 0}
            name={product?.name}
            required_prescripation={product?.prescription_upload_required}
            price={product?.prices_with_tax}
            sku={product?.sku}
            barCode={product?.barcode}
            free_gifts={product?.free_gifts}
            entity_id={product?.entity_id}
            categories={product?.category}
            brand={{
              brandLogo: product?.brand_logo,
              url: product?.brand_url,
              brandLabel: product?.brand_label,
              id: product?.brands?.[0],
            }}
            rabeh_earn_points={product?.rabeh_earn_points}
            label={product?.label}
            productCategory={product.category}
            // stock_innova={product?.stock_innova}
            session={session}
            cart_rules={
              product?.cart_rule?.filter((r) => r.is_active === '1')?.length
                ? product?.cart_rule?.filter((r) => r.is_active === '1')
                : product?.type_id === 'bundle' &&
                    product?.option_text_offer_type
                  ? [
                      {
                        rule_id: Array.isArray(product?.offer_type)
                          ? product?.offer_type?.at(0)
                          : product?.offer_type,
                        labels: [
                          ,
                          product?.option_text_offer_type || '',
                          product?.option_text_offer_type || '',
                        ],
                        name: 'Offers',
                      },
                    ]
                  : []
            }
            eligible_for_tabby={product?.eligible_for_tabby}
            eligible_for_tamara={product?.eligible_for_tamara}
            bundleProductOptions={product?.bundle_product_options}
            stock={product?.stock}
          />
        </div>
      </div>

      <div className='flex w-full flex-col gap-3 lg:w-[30%] lg:gap-6 lg:ps-5 ltr:lg:border-l ltr:lg:border-l-[#f3f4f6] rtl:lg:border-r rtl:lg:border-r-[#f3f4f6]'>
        {!!product?.tier_prices?.length && (
          <BundleDeal
            tier_prices={product?.tier_prices}
            selectedBundle={selectedBundle}
            setSelectedBundle={setSelectedBundle}
          />
        )}

        <CtaButtons product={product} selectedBundle={selectedBundle} />
        <div className='hidden flex-col gap-[9px] sm:flex sm:gap-3 lg:gap-[15px]'>
          <ProductDelivery />
          <FindStore entity_id={product?.entity_id} />
          <ExtraStores />
        </div>
      </div>
    </div>
  );
};

export default Details;
